import { render, staticRenderFns } from "./followupSteps.vue?vue&type=template&id=b6398792"
import script from "./followupSteps.vue?vue&type=script&lang=js"
export * from "./followupSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports